<script>
	import '../app.postcss'; // tailwind

	import { locale, loadTranslations } from '$lib/locales';
	import { page } from '$app/stores';
	import { afterNavigate } from '$app/navigation';
	import { loadPolyfills } from '$lib/js/polyfills';
	import { onMount } from 'svelte';

	import FaviconRP from 'Assets/faviconRP.png';

	onMount(async () => {
		$locale = $page.data.locale;
		loadPolyfills();
		await loadTranslations($page.data.locale, $page.url.pathname);
	});

	afterNavigate(async () => {
		// reload translations on change of either locale or pathname
		await loadTranslations($page.data.locale, $page.url.pathname);
	});
</script>

<svelte:head>
	<link rel="icon" type="image/png" href={FaviconRP} />
</svelte:head>

<slot />

<style>
	:global(.noselect) {
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Old versions of Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
	}
	:global(*) {
		--danger-color: #ff8c26;
		--orange: #ec8058;
		--green: #68c58b;
		--gray-text: #707c97;
		--turquoise-text: #75c5cd;
		--medium-gray: #dbd9d9;
		--icon-blue: #5781cf;
	}
	:global(.no-scrollbar) {
		-ms-overflow-style: none; /* Internet Explorer 10+ */
		scrollbar-width: none; /* Firefox */
	}

	:global(.no-scrollbar::-webkit-scrollbar) {
		display: none; /* Safari and Chrome */
	}
	:global(::-webkit-scrollbar) {
		width: 5px;
		height: 10px;
	}
	:global(::-webkit-scrollbar-thumb) {
		background-color: rgb(199, 199, 199);
		border-radius: 4px;
	}
	:global(select, input) {
		outline: none;
	}
	:global(select option) {
		background-color: var(--secondary-button-a);
	}
</style>
